import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/analytics";

const FOOTER_LINKS = [
  { label: "How It Works", id: "how-it-works" },
  { label: "Role Suites", id: "role-suites" },
  { label: "Impact", id: "impact" },
  { label: "Pricing", id: "pricing" },
  { label: "FAQ", id: "faq" },
];

export function Footer() {
  return (
    <footer className="bg-navy pb-10 pt-16 text-slate-300" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 border-b border-navy-700 pb-12 md:grid-cols-3">
          <div>
            <Logo dark />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Stop typing. Start guiding. Own your documentation workflow forever.
            </p>
          </div>
          <nav aria-label="Footer">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.22em] text-teal-400">Explore</p>
            <ul className="mt-4 space-y-2.5">
              {FOOTER_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    data-testid={`footer-link-${l.id}`}
                    onClick={(e) => { e.preventDefault(); scrollToId(l.id); }}
                    className="text-sm text-slate-300 transition-colors hover:text-white"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/verify" data-testid="footer-link-verify" className="text-sm text-slate-300 transition-colors hover:text-white">
                  Verify a License
                </Link>
              </li>
              <li>
                <a
                  href="#demo"
                  data-testid="footer-link-request-demo"
                  onClick={(e) => { e.preventDefault(); scrollToId("demo"); }}
                  className="text-sm text-slate-300 transition-colors hover:text-white"
                >
                  Request Demo
                </a>
              </li>
              <li>
                <Link to="/onboarding" data-testid="footer-link-onboarding" className="text-sm text-slate-300 transition-colors hover:text-white">
                  Onboarding Form
                </Link>
              </li>
            </ul>
          </nav>
          <div>
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.22em] text-teal-400">Contact</p>
            <a
              href="mailto:sales@verachart.org"
              data-testid="footer-email-link"
              className="mt-4 inline-block text-sm font-medium text-white underline decoration-teal-500 underline-offset-4 transition-colors hover:text-teal-300"
            >
              sales@verachart.org
            </a>
            <ul className="mt-6 space-y-2.5">
              <li>
                <Link to="/privacy-policy" data-testid="footer-link-privacy" className="text-sm text-slate-400 transition-colors hover:text-white">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" data-testid="footer-link-terms" className="text-sm text-slate-400 transition-colors hover:text-white">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/admin" data-testid="footer-link-admin" className="text-sm text-slate-500 transition-colors hover:text-white">
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <p className="pt-8 text-xs text-slate-500">© 2026 VeraChart. All rights reserved.</p>
      </div>
    </footer>
  );
}
